import { Box, Button, Typography, makeStyles } from "@material-ui/core";

import { EPricePaymentType, Product } from "../../api/Product/Product";
import { TF } from "../../components/typography/TF";
import { fontFamily } from "../../app/theme";
import { useDispatch } from "react-redux";
import { setSelectedLeadProductId } from "../../store/QuoteSlice";
import { sliderSettings } from "../../components/Slider";
import Slider from "react-slick";
import { useRef, useState } from "react";
import { useBreakpoint } from "../../hooks/useBreakpoint";
import { solarGrantAmountForLeadProduct } from "../../app/utils";

export const PackageInfoSlider = ({ products }: Props) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [activeSlide, setActiveSlide] = useState<number>(0);
  const { isMoreThanSm, isMoreThanLg } = useBreakpoint();

  const sliderRef = useRef<Slider>(null);

  sliderSettings.beforeChange = (_current, next) => setActiveSlide(next);
  sliderSettings.dots = false;

  const handleSetSelectedProduct = (id: string) => {
    dispatch(setSelectedLeadProductId(id));
    window.scrollTo(0, 0);
  };

  const slideRender = function (product: Product) {
    if (product === null || product.media[0].mediaFiles[0].url === null) {
      return null;
    }

    const oncePrice = product.prices.find((x) => x.paymentType === EPricePaymentType.Once);
    const monthlyPrice = product.prices.find((x) => x.paymentType === EPricePaymentType.Monthly);

    const grantAmountAvailable = solarGrantAmountForLeadProduct(product) ?? 0;

    return (
      <Box key={product.id} className={classes.box}>
        <Box className={classes.boxClipPath}>
          <Box className={classes.boxContent}>
            <img alt={product.name} src={product.media[0].mediaFiles[0].url} className={classes.boxImage} />

            <Box className={classes.boxGrowableContent}>
              <Typography variant="body2">{product.name}</Typography>

              {(oncePrice || monthlyPrice) && (
                <Box py={2}>
                  <Typography variant="body2">Starting from</Typography>
                  {oncePrice && (
                    <TF format="price" variant="body1" bold>
                      {oncePrice.price - grantAmountAvailable}
                    </TF>
                  )}
                  {oncePrice && monthlyPrice && (
                    <Box my={2}>
                      <Typography variant="body2">Or</Typography>
                    </Box>
                  )}
                  {monthlyPrice && (
                    <Box display="flex" flexDirection="row" alignItems="baseline">
                      <TF format="price" variant="body1" bold>
                        {monthlyPrice.price}
                      </TF>
                      <Box marginLeft={1}>
                        <TF variant="body2">per month</TF>
                      </Box>
                    </Box>
                  )}
                </Box>
              )}
            </Box>

            <Box py={1}>
              <Button
                variant="contained"
                color="secondary"
                fullWidth={true}
                className={classes.btnBookNow}
                href="https://swyftenergy4.schedulista.com/"
                target="_blank"
              >
                Book a Call
              </Button>
            </Box>
            <Box py={1}>
              <Button
                variant="outlined"
                color="secondary"
                fullWidth={true}
                className={classes.btnBookNow}
                onClick={() => handleSetSelectedProduct(product.id)}
              >
                View Details
              </Button>
            </Box>
          </Box>
        </Box>
      </Box>
    );
  };

  // return <Box className={classes.wrapper}>{products.map((p) => slideRender(p))}</Box>;

  var slidesToShow = isMoreThanSm ? (isMoreThanLg ? 3 : 2) : 1;
  slidesToShow = Math.min(slidesToShow, products.length);

  return (
    <Box className={classes.sliderWrapper}>
      <Slider {...sliderSettings} slidesToShow={slidesToShow} className={classes.imageSlider} ref={sliderRef}>
        {products.map((p) => slideRender(p))}
      </Slider>

      {slidesToShow < products.length && (
        <Box display={"flex"} width={"100%"} justifyContent={"center"} alignItems={"center"}>
          {products.map((_item, idx) => (
            <Box
              key={idx}
              width={"68px"}
              height={"3px"}
              bgcolor={activeSlide === idx ? "#f7815c" : "#706483"}
              mr={idx === 0 ? "8px" : 0}
              onClick={() => sliderRef.current?.slickGoTo(idx)}
            />
          ))}
        </Box>
      )}
    </Box>
  );
};

const useStyles = makeStyles((theme) => ({
  imageSlider: {
    "height": "100%",
    "& .slick-list": {
      "height": "100%",
      "& .slick-track": {
        height: "100%"
      }
    },
    "& .slick-dots li": {
      margin: 0
    },
    "& .slick-dots li button": {
      [theme.breakpoints.down("sm")]: {
        width: "10px",
        height: "10px"
      }
    },
    "& .slick-dots li button:before": {
      fontSize: "10px",
      color: "#f7815c",
      [theme.breakpoints.down("sm")]: {
        fontSize: "7px",
        width: "10px",
        height: "10px"
      }
    },
    "& .slick-dots .slick-active button:before": {
      opacity: 1
    },
    "& .slick-slide div": {
      height: "100%"
    },
    "& .slick-slide img": {
      maxHeight: "321px",
      maxWidth: "300px",
      objetFit: "cover",
      outline: "transparent",
      [theme.breakpoints.down("md")]: {
        maxHeight: "320px",
        maxWidth: "220px"
      }
    },
    "& .slick-slide .MuiBox-root": {
      outline: "transparent"
    },
    "& .slick-next, & .slick-prev": {
      display: "none !important"
    },
    "& .slick-dots": {
      bottom: "20px",
      [theme.breakpoints.down("sm")]: {
        bottom: "0px"
      }
    }
  },
  sliderWrapper: {
    marginBottom: theme.spacing(12)
  },
  wrapper: {
    display: "flex",
    justifyContent: "center",
    alignItems: "stretch",
    [theme.breakpoints.down("sm")]: {
      "display": "flex",
      "flex-wrap": "wrap",
      "textAlign": "center"
    }
  },
  box: {
    width: 430,
    borderRadius: 4,
    position: "relative",
    filter: "drop-shadow(0px 5px 15px rgba(0, 0, 0, 0.07)) drop-shadow(0px 15px 15px rgba(50, 50, 93, 0.1))",
    [theme.breakpoints.down("sm")]: {
      width: "48%"
    },
    [theme.breakpoints.down("xs")]: {
      width: "100%",
      marginBottom: "30px"
    }
  },
  boxClipPath: {
    filter: "url(#round)",
    height: "100%"
  },
  boxContent: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    // height: "100%",
    padding: theme.spacing(5),
    margin: theme.spacing(4),
    background: "#fff",
    clipPath: "polygon(calc(100% - 50px) 0, calc(100% - 50px) 50px, 100% 50px, 100% 100%, 0 100%, 0 0)",
    [theme.breakpoints.down("sm")]: {
      clipPath: "polygon(calc(100% - 40px) 0, calc(100% - 40px) 40px, 100% 40px, 100% 100%, 0 100%, 0 0)"
    }
  },
  boxGrowableContent: {
    flex: "1"
  },
  boxImage: {
    height: "321px",
    maxWidth: "300px",
    margin: "auto"
  },
  btnBookNow: {
    "borderRadius": "18px",
    "boxShadow": "none",
    "height": "38px",
    "fontSize": "14px",
    "fontFamily": fontFamily.Axiforma,
    "& .MuiButton-label": { marginTop: "5px" },
    "&:hover": { boxShadow: "none" },
    [theme.breakpoints.down("sm")]: {
      "& .MuiButton-label": { marginTop: "2px" }
    }
  }
}));

interface Props {
  products: Product[];
}
